import { chain } from 'lodash';
import { ActionType } from '../../classes/package-listing-actions';
import { IEventFilter, IPerformanceErrorMessage, IPerformanceSeatStatus } from '../../classes/package-listing';
import { IPackage, IPerformance, IPerformancePricing, IPackagePricing, IPackageRequest } from '../../custom/classes/production';
import { IPackageListingAppState } from '..';
import { getPerformancePricing, getPackagePricing } from './package-api.actions';

/**
 * Use only after events have been updated.
 */
export function eventsUpdated() {
    return {
        type: ActionType.PerformancesUpdated
    }
}

/**
 * Update the events being stored in the redux state.
 * @param events
 */
//export function updateEvents(performanceGroups: Array<IPerformanceGroup>) {
//    return {
//        type: ActionType.UpdateEvents,
//        value: performanceGroups
//    }
//}


export function loadPackage(packageDetail: IPackage) {
    return {
        type: ActionType.LoadPackage,
        value: packageDetail
    }
}

export function loadPackages(packages: Array<IPackage>) {
    return {
        type: ActionType.LoadPackages,
        value: packages
    }
}

export function loadPackageRequest(packageDetail: IPackageRequest) {
    return (dispatch, getState: () => IPackageListingAppState) => {
        const currentState = getState();

        dispatch({ type: ActionType.LoadPackageRequest });

        chain(packageDetail.requestedPriceTypeIds)
            .groupBy(id => id)
            .forEach((priceTypes, ptId) => {
                dispatch(updatePriceTypeQuantity(+ptId, priceTypes.length));
            })
            .value();

        if (packageDetail.packageId > 0) {
            if (currentState.packageListing) {
                dispatch(selectPackage(currentState.packageListing.packages.filter(pkg => pkg.id == packageDetail.packageId)[0]));
            }
            else {
                console.error("There aren't any packages being loaded");
            }
        }

        if (packageDetail.subPackageZones) {
            for (let subPackageId in packageDetail.subPackageZones) {
                let zoneId = packageDetail.subPackageZones[subPackageId];
                dispatch(updateSelectedZone(+subPackageId, zoneId));
            }
        } else if (packageDetail.zoneId > 0) {
            dispatch(updateSelectedZone(packageDetail.packageId, packageDetail.zoneId));
        }
    }
}

export function upsertEventFilter(filterFunction: IEventFilter) {
    return {
        type: ActionType.UpdatePerformancesFilter,
        value: filterFunction
    }
}

export function removeEventFilter(filterKey: string) {
    return {
        type: ActionType.RemovePerformancesFilter,
        value: filterKey
    }
}

export function removeAllEventFilters() {
    return {
        type: ActionType.RemoveAllPerformancesFilters
    }
}

export function updateSettings(settings) {
    return {
        type: ActionType.UpdateSettings,
        value: settings
    }
}

export function selectPerformance(performance: IPerformance) {
    return (dispatch, getState: () => IPackageListingAppState) => {
        dispatch(addItemToCart(performance.performanceId));
        dispatch(getPerformancePricing(performance.performanceId, getState().packageListing.packageDetail.id))
    }
}

export function selectPackage(pkg: IPackage) {
    return (dispatch, getState: () => IPackageListingAppState) => {

        if (pkg) {
            // super package
            if (pkg.subPackages.length > 0) {
                pkg.subPackages.forEach(subPackage => {
                    dispatch(addItemToCart(subPackage.id, pkg.id));
                });
            } else {
                dispatch(addItemToCart(pkg.id));
            }
            dispatch(getPackagePricing(pkg.id));
        }

    }
}

export function receivePerformancePricing(performancePricing: Array<IPerformancePricing>) {
    return {
        type: ActionType.ReceivePerformancePricing,
        value: performancePricing
    }
}

export function receivePackagePricing(packagePricing: IPackagePricing) {
    return {
        type: ActionType.ReceivePackagePricing,
        value: packagePricing
    }
}

export function addItemToCart(itemId: number, parentPackageId: number = undefined) {
    return {
        type: ActionType.AddItemToCart,
        value: {
            itemId,
            packageId: parentPackageId
        }
    }
}

export function removeItemFromCart(itemId: number) {
    return {
        type: ActionType.RemoveItemFromCart,
        value: itemId
    }
}

export function updateSelectedZone(itemId: number, zoneId: number) {
    return {
        type: ActionType.UpdateSelectedZone,
        value: {
            itemId: itemId,
            zoneId: zoneId
        }
    }
}

export function removeSelectedZone(cartItemId: number) {
    return {
        type: ActionType.RemoveSelectedZone,
        value: cartItemId
    }
}

export function updatePriceTypeQuantity(priceTypeId: number, quantity: number) {
    return {
        type: ActionType.UpdatePriceTypeQuantity,
        value: {
            priceTypeId: priceTypeId,
            quantity: quantity
        }
    }
}

export function clearPriceTypeQuantities() {
    return {
        type: ActionType.ClearPriceTypeQuantities,
        value: {
        }
    }
}

export function updateOrderNotes(orderNotes: string) {
    return {
        type: ActionType.UpdateOrderNotes,
        value: orderNotes
    }
}

export function updateSeatingPreferences(preferences: string) {
    return {
        type: ActionType.UpdateSeatingPreferences,
        value: preferences
    }
}

export function updateAccessibleSeatingRequest(request: boolean) {
    return {
        type: ActionType.UpdateAccessibleSeatingRequest,
        value: request
    }
}
export function processPackageRequest() {
    return {
        type: ActionType.UpdatePackageProcessing,
        value: true
    }
}


export function processPackageRequestError(errorMessages: Array<IPerformanceErrorMessage>) {
    return {
        type: ActionType.UpdatePackageProcessingErrors,
        value: errorMessages
    }
}

export function toggleMiniCart(openMiniCart: boolean) {
    return {
        type: ActionType.ToggleMiniCart,
        value: openMiniCart
    }
}

export function performanceAddedToCart(performanceAddedToCart: boolean) {
    return {
        type: ActionType.PerformanceAddedToCart,
        value: performanceAddedToCart
    }
}

export function updatePerformanceSeatStatuses(performanceSeatStatuses: Array<IPerformanceSeatStatus>) {
    return {
        type: ActionType.UpdatePerformanceSeatStatuses,
        value: performanceSeatStatuses
    }
}